var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductListSlider',{attrs:{"config":_vm.config,"products":_vm.products,"categoryBlockName":'ProductSlider',"showMore":_vm.showMore}})
}
var staticRenderFns = []

export { render, staticRenderFns }